<template>
  <div>
    <Accordeon title="Warum berücksichtigt der Service nur Autobahnen und bestimmte Bundesstraßen?">
      <template slot="answer">
        <ul>
          <li>
            Dieser Service bietet Ihnen Informationen direkt aus der Verkehrszentrale Hessen.
            Dort wird der Verkehr auf hessischen Autobahnen und einigen Bundesstraßen gesteuert und überwacht.
            Auch Baumaßnahmen werden hier koordiniert,
            damit möglichst wenige Störungen für den fließenden Verkehr entstehen.
          </li>
          <li>
            Im Service stellen wir nur Informationen zur Verfügung,
            die in unserem eigenen Zuständigkeitsbereich liegen.
            Kleinere und innerstädtische Straßen werden bspw. von den zuständigen Gemeinden betreut –
            weshalb wir für diese Bereiche keine Informationen abbilden.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Was bedeutet “Trend in 30 Min”?">
      <template slot="answer">
        <ul>
          <li>
            Über diese Funktion bekommen Sie die Verkehrsstörungen auf der Karte angezeigt,
            wie wir sie in 30 Minuten erwarten.
            Für die Ermittlung dieser prognostizierten Verkehrslage setzen wir spezielle
            systemgestützte Berechnungen auf Grundlage der aktuellen Verkehrsdaten ein.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Welchen Zeitraum umfassen die zukünftigen Baustellen?">
      <template slot="answer">
        <ul>
          <li>Es werden geplanten Baustellen der nächsten Woche angezeigt.</li>
        </ul>
      </template>
    </Accordeon>
  </div>
</template>

<script>
import Accordeon from "./../../CoreComponents/Accordeon.vue";
export default {
  name: "FAQFunktionen",
  components: { Accordeon }
};
</script>

<style scoped>
</style>
